export default class ScenarioCharacter extends Phaser.GameObjects.Container {
  constructor(scene, config) {
    const { id, x = 0, y = 0 } = config;
    super(scene, x, y);
    scene.add.existing(this);
    this.id = id;
    this.ignoreSFX = config.ignoreSFX || [];
    this.spine = scene.add.spine(0, 0, id, null, false);
    this.spine.visible = true;
    this.spine.on('event', this.handleSpineEvents, this);
    if (this.spine.findSkin('normal')) this.spine.setSkinByName('normal');
    this.add(this.spine);
    this.visible = false;
  }

  handleSpineEvents(track, event) {
    if (event.data.name == 'sfx') {
      if (!this.ignoreSFX.includes(event.stringValue)) {
        this.scene.game.soundController.playSFX('sfx', event.stringValue);
      }
    }
  }

  parseChainItem(chain) {
    if (chain.includes('|')) {
      const split = chain.split('|');
      const animId = split[0];
      const repeatTotal = parseInt(split[1]);
      return { animId, repeatTotal };
    }
    return { animId: chain, repeatTotal: 0 };
  }

  playChainItem(chainItem, onComplete) {
    this.repeatCount = 1;
    let { animId, repeatTotal } = this.parseChainItem(chainItem);
    // console.log('playChainItem', animId, repeatTotal);
    const onCompleteChainItem = () => {
      this.repeatCount++;
      ``;
      if (this.repeatCount < repeatTotal) {
        this.spine.once('complete', onCompleteChainItem, this);
      } else {
        this.spine.once('complete', onComplete, this);
      }
      this.spine.play(animId, false);
    };

    if (repeatTotal > 0) {
      this.spine.once('complete', onCompleteChainItem, this);
    } else {
      this.spine.once('complete', onComplete, this);
    }
    this.spine.play(animId, false);
  }

  playChain(animation, loop, ignoreIfPlaying = true, callback, callbackscope) {
    // console.log('playChain', this.id, animation);
    const chain = animation.split(',');
    this.chainIndex = 0;

    const onComplete = () => {
      this.chainIndex++;
      const index = this.chainIndex % chain.length;

      if (this.chainIndex < chain.length - 1) {
        this.playChainItem(chain[index], onComplete);
      } else {
        const anim = chain[index];
        callback && callback.apply(callbackscope, ['complete']);
        this.spine.play(anim, true);
      }
    };
    const onCompleteEvent = (t, e) => {
      callback.apply(callbackscope, [e.data.name]);
    };
    callback && this.spine.once('event', onCompleteEvent, this);
    this.playChainItem(chain[0], onComplete);
  }

  play(animation, loop, ignoreIfPlaying = true, callback, callbackscope) {
    if (animation.includes(',')) {
      this.playChain(animation, loop, ignoreIfPlaying, callback, callbackscope);
    } else {
      const onComplete = (t, e) => {
        callback.apply(callbackscope, ['complete']);
      };
      const onCompleteEvent = (t, e) => {
        callback.apply(callbackscope, [e.data.name]);
      };
      callback && this.spine.once('event', onCompleteEvent, this);
      callback && this.spine.once('complete', onComplete, this);
      this.spine.play(animation, loop, ignoreIfPlaying);
    }
    this.spine.state.timeScale = 1;
  }

  setAnimation(animation, loop, ignoreIfPlaying) {
    this.spine.setAnimation(0, animation, loop, ignoreIfPlaying);
    this.spine.state.timeScale = 0;
  }

  setTalking(value) {
    if (!this.spine) return;
    if (value && this.spine.findSkin('lipflap')) {
      this.spine.setSkinByName('lipflap');
      // console.log('setTalking lipflap');
    } else if (!value && this.spine.findSkin('normal')) {
      this.spine.setSkinByName('normal');
      // console.log('setTalking normal');
    }
  }

  destroy(fromScene) {
    if (this.spine) {
      this.spine.removeAllListeners('event');
      this.spine.removeAllListeners('complete');
      this.spine.destroy();
    }
    this.spine = null;
    super.destroy(fromScene);
  }
}
